module.exports = {
  "props": [
    {
      "name": "tag",
      "type": "string",
      "default": "'main'",
      "source": "v-main",
      "description": {
        "en": "Specify a custom tag used on the root element.",
        "ja": "コンポーネント内で使用するカスタムタグを指定します。",
        "zh-Hans": "指定在根元素上使用的自定义标签。"
      }
    }
  ],
  "mixins": [],
  "slots": [],
  "events": [],
  "functions": [],
  "name": "v-content",
  "sass": [],
  "component": true
}